<div class="properties-comparables-delete-sidebar " [class.close]="shouldClose">
  <section class="import-section preview-grids grids-comps">
    <div class="closeButton" (click)="onCloseClicked()"></div>
    <div class="comps-header">
      <h3>{{ 'pixComps.deleteTitle' | translate }}</h3>
    </div>
    <div class="comps-header">
      <input class="propertiesCheckbox" name="deleteComps" type="radio" (change)="onSelectedCompsChange(compsIntegrationType.Sale)" [disabled]="!hasSalesComparables">
      &nbsp;&nbsp;
      <label>{{ 'pixComps.deleteSale' | translate }}</label>
    </div>
    <div class="comps-header">
      <input class="propertiesCheckbox" name="deleteComps" type="radio" (change)="onSelectedCompsChange(compsIntegrationType.Lease)" [disabled]="!hasLeaseComparables">
      &nbsp;&nbsp;
      <label>{{ 'pixComps.deleteLease' | translate }}</label>
    </div>
    <div class="comps-header">
      <input class="propertiesCheckbox" name="deleteComps" type="radio" (change)="onSelectedCompsChange(compsIntegrationType.IE)" [disabled]="!hasIEComparables">
      &nbsp;&nbsp;
      <label>{{ 'pixComps.deleteIE' | translate }}</label>
    </div>
    <div class="comps-header">
      <input class="propertiesCheckbox" name="deleteComps" type="radio" (change)="onSelectedCompsChange(compsIntegrationType.All)">
      &nbsp;&nbsp;
      <label>{{ 'pixComps.deleteAll' | translate }}</label>
    </div>
  </section>
  <div class="buttons-container-delete">
    <button kendoButton class="next" (click)="onDelete()" [disabled]="typeOfDeletedComps === CompsIntegrationEnum.None">{{ 'pixComps.deleteContinue' | translate }}</button>
  </div>
</div>
